'use client';

import { KeyboardEvent, useState } from 'react';

interface MessageInputProps {
  onSendMessage: (message: string) => void;
  placeholder?: string;
}

export function MessageInput({ onSendMessage, placeholder = '메시지를 입력하세요...' }: MessageInputProps) {
  const [message, setMessage] = useState('');

  const handleSend = () => {
    const trimmedMessage = message.trim();
    if (trimmedMessage) {
      onSendMessage(trimmedMessage);
      setMessage('');
    }
  };

  const handleKeyPress = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div className="p-4 border-t border-[#DEE2E7] bg-white">
      <div className="flex items-end space-x-3">
        {/* Text input */}
        <div className="flex-1 relative">
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder={placeholder}
            className="w-full px-4 border border-[#DEE2E7] rounded-lg resize-none focus:outline-none focus:ring-2 focus:ring-[#2563EB] focus:border-transparent transition-colors duration-200 max-h-32 flex items-center"
            rows={1}
            style={{
              height: '40px',
              minHeight: '40px',
              lineHeight: '20px',
              paddingTop: '10px',
              paddingBottom: '10px',
            }}
            onInput={(e) => {
              const target = e.target as HTMLTextAreaElement;
              target.style.height = '40px';
              const newHeight = Math.min(target.scrollHeight, 128);
              if (newHeight > 40) {
                target.style.height = newHeight + 'px';
              }
            }}
          />
        </div>

        {/* Send button */}
        <button
          onClick={handleSend}
          disabled={!message.trim()}
          className={`px-4 rounded-lg font-medium transition-all duration-200 flex items-center justify-center ${message.trim()
            ? 'bg-[#2563EB] hover:bg-[#1D4ED8] text-white'
            : 'bg-[#F5F7F9] text-[#ACB3BE] cursor-not-allowed'
            }`}
          style={{ height: '40px', minHeight: '40px' }}
          aria-label="메시지 보내기"
        >
          {/* Send icon */}
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M22 2L11 13M22 2L15 22L11 13M22 2L2 9L11 13"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>
  );
}